import { UseAxiosResult } from "axios-hooks";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

import { UseSelectUserManagementApi } from "./setup";

export interface VerifyLoginBody {
  verificationId: string;
  verificationCode: string;
}

export interface ResendEmailBody {
  verificationId: string;
}

export const useVerifyLoginMutation = (): UseAxiosResult<
  null,
  VerifyLoginBody
> => {
  return UseSelectUserManagementApi<null, VerifyLoginBody>(
    {
      url: formatUrl(api.login.verify.external),
      method: "POST",
    },
    {
      manual: true,
    }
  );
};

export const useResendVerifyLoginEmailMutation = (): UseAxiosResult<
  null,
  ResendEmailBody
> => {
  return UseSelectUserManagementApi<null, ResendEmailBody>(
    {
      url: formatUrl(api.login.verify.resend),
      method: "POST",
    },
    {
      manual: true,
    }
  );
};
